import { render } from "./BaseFormField.vue?vue&type=template&id=50588a2a&scoped=true&ts=true"
import script from "./BaseFormField.vue?vue&type=script&lang=ts"
export * from "./BaseFormField.vue?vue&type=script&lang=ts"

import "@/styles/baseformfield.scss?vue&type=style&index=0&id=50588a2a&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50588a2a"]])

export default __exports__